var _circle, _circle2, _g, _line, _rect, _line2, _rect2, _rect3, _path, _path2, _path3, _circle3, _circle4, _path4, _path5, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobotBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 278,
    viewBox: "0 0 276 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 138,
    r: 138,
    fill: "url(#paint0_linear_2_105)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_105",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 276,
    height: 277
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 139.426,
    r: 138,
    fill: "url(#paint1_linear_2_105)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_105)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.919,
    cy: 300.468,
    rx: 113.859,
    ry: 98.2034,
    fill: "#42B9A7"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 238.159,
    y1: 20.0898,
    x2: 238.159,
    y2: 119.716,
    stroke: "#248477",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.5459,
    y: 114.023,
    width: 216.332,
    height: 56.9295,
    rx: 5,
    fill: "#5FCCB9"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 39.0854,
    y1: 20.0898,
    x2: 39.0854,
    y2: 119.716,
    stroke: "#248477",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0854,
    y: 102.638,
    width: 199.253,
    height: 79.7013,
    rx: 5,
    fill: "#42B9A7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.4717,
    y: 96.9446,
    width: 173.635,
    height: 91.0872,
    rx: 5,
    fill: "#248477"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.3179 88.8695C52.3179 83.2045 56.2992 78.2956 61.8533 77.1804C119.579 65.5896 154.247 65.5797 210.777 77.1507C216.307 78.2827 220.26 83.1806 220.26 88.8257V197.619C220.26 203.244 216.369 208.089 210.831 209.072C196.698 211.581 168.245 215.785 136.289 215.785C104.332 215.785 75.8795 211.581 61.7469 209.072C56.209 208.089 52.3179 203.244 52.3179 197.619V88.8695Z",
    fill: "#42B9A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5503 106.233C66.5503 100.445 70.6866 95.4679 76.3917 94.49C123.667 86.386 152.778 86.377 199.08 94.4628C204.764 95.4556 208.874 100.423 208.874 106.194V180.391C208.874 186.143 204.803 191.063 199.113 191.91C186.631 193.768 163.52 196.571 137.712 196.571C111.905 196.571 88.7933 193.768 76.3111 191.91C70.6212 191.063 66.5503 186.144 66.5503 180.391V106.233Z",
    fill: "#5FCCB9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3965 108.691C69.3965 102.892 73.5419 97.9096 79.2602 96.9459C124.258 89.3627 152.135 89.3536 196.207 96.9187C201.906 97.8968 206.027 102.871 206.027 108.652V177.85C206.027 183.613 201.933 188.54 196.229 189.371C184.151 191.131 162.195 193.725 137.712 193.725C113.228 193.725 91.2728 191.131 79.1945 189.371C73.4911 188.54 69.3965 183.613 69.3965 177.85V108.691Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.4382,
    cy: 138.219,
    r: 9.96266,
    fill: "#385050"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.986,
    cy: 138.219,
    r: 9.96266,
    fill: "#385050"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.633 159.567C124.745 163.863 133.917 169.878 137.712 159.567",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.791 159.567C150.679 163.863 141.507 169.878 137.712 159.567",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.5915,
    cy: 141.065,
    r: 4.26971,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.139,
    cy: 141.065,
    r: 4.26971,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.4384,
    cy: 132.526,
    r: 1.42324,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.986,
    cy: 132.526,
    r: 1.42324,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.068,
    cy: 21.513,
    r: 7.11619,
    fill: "#248477"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5088,
    cy: 21.513,
    r: 7.11619,
    fill: "#248477"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_105",
    x1: 138,
    y1: 0,
    x2: 138,
    y2: 276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEEBF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_105",
    x1: 138,
    y1: 1.4256,
    x2: 138,
    y2: 277.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEEBF4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotBig);
export default __webpack_public_path__ + "static/media/robotBig.b6a33d3d88943f176187494586096faa.svg";
export { ForwardRef as ReactComponent };